import { CmsFlashCardQuizBlockLoadable } from './CmsFlashCardQuizBlockLoadable';

import type { CmsApiFlashCardQuizBlockData } from '#/modules/cms/api/types/blocks/CmsApiFlashCardQuizBlock';
import type { CmsBlockMapping } from '#/modules/cms/blocks/CmsBlockMapping';
import { CmsMappedBlockWidth } from '#/modules/cms/mappers/CmsMappedBlockWidth';

export const CmsFlashCardQuizBlockMapping: CmsBlockMapping<CmsApiFlashCardQuizBlockData> =
  {
    invariant: [],
    width: CmsMappedBlockWidth.NARROW,
    Component: CmsFlashCardQuizBlockLoadable,
  };
